(() => {
  const cfg = window.PLP_CACHE;
  if (!cfg || !cfg.enabled) return;
  if (!cfg.targetKey || !cfg.refreshUrl) return;

  const ua = navigator.userAgent || "";
  if (/bot|crawler|spider|slurp|bingpreview|google|yahoo|duckduck|baidu|yandex/i.test(ua)) {
    return;
  }

  function latestRefreshSlotUtc(now, slotsJst) {
    const slots = Array.isArray(slotsJst) && slotsJst.length > 0
      ? slotsJst.slice().sort((a, b) => a - b)
      : [6, 10, 16];

    const jst = new Date(now.getTime() + 9 * 60 * 60 * 1000);
    const y = jst.getUTCFullYear();
    const m = jst.getUTCMonth();
    const d = jst.getUTCDate();
    const h = jst.getUTCHours();

    let slot = null;
    for (const s of slots) {
      if (h >= s) slot = s;
    }

    if (slot === null) {
      const prevSlot = slots[slots.length - 1];
      return new Date(Date.UTC(y, m, d - 1, prevSlot - 9, 0, 0));
    }

    return new Date(Date.UTC(y, m, d, slot - 9, 0, 0));
  }

  function shouldRefresh() {
    if (!cfg.hasCachedProducts) return true;
    if (!cfg.zetaCheckedAt) return true;

    const checkedAt = new Date(cfg.zetaCheckedAt);
    if (Number.isNaN(checkedAt.getTime())) return true;

    const latestSlot = latestRefreshSlotUtc(new Date(), cfg.refreshSlotsJst);
    return checkedAt < latestSlot;
  }

  if (!shouldRefresh()) return;

  fetch(cfg.refreshUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      target_key: cfg.targetKey
    }),
    credentials: "omit",
    keepalive: true
  }).catch(() => {
    // 当該アクセス中の表示制御には使わない
  });
})();